( function () {
   
    'use strict';
  
    ( function ( $ ) {
        var swiper = new Swiper(".hero-banner-Swiper", {
            loop: true,
            slidesPerView: 1,
            pagination: {
                el: '.swiper-pagination',
                clickable: true
            },
            
          });
} )( jQuery );
} )();